<template>
    <v-select
        :label=label
        :items=choices
        :value="value"
        v-on:change="onChange"
        return-object
    />
</template>

<script>

const TestData = require("@/js/TestData.js");

export default {
    props: {
        label: {
            type: String,
            default: () => { return 'Timezone'; }
        },
        value: {
            type: String,
            default: () => { return 'US/Arizona'; }
        }
    },

    data() {
        return {
            choices: this.prettyPrintTimeZones(TestData.getCommonTimeZones()),
            last_value: null,
        }
    },

    mounted () 
    {
        for ( let i = 0; i < this.choices.length; i++ )
        {
            if ( this.choices[i].value === this.value )
            {
                this.last_value = this.choices[i];
                return;
            }
        }

        let common_timezones = TestData.getCommonTimeZones();
        common_timezones.push({
            'text' : this.value,
            'value' : this.value,
        });

        this.choices = this.prettyPrintTimeZones(common_timezones);

        this.last_value = this.choices[this.choices.length-3];
    },

    methods: 
    {
        onChange(new_value) 
        {
            if ( new_value.value == 'more-choices' )
            {
                this.choices = this.prettyPrintTimeZones(TestData.getAllTimeZones());
                this.value = this.last_value;
                this.$forceUpdate();
                //setTimeout(() => { this.value = this.last_value; this.$forceUpdate(); }, 100);
                return;
            }

            this.last_value = new_value;
            this.$emit('input',new_value.value);
        },

        prettyPrintTimeZones(time_zones)
        {
            let ret = [];

            for ( let i = 0; i < time_zones.length; i++ )
            {
                ret.push({
                    'text' : time_zones[i].value,
                    'value' : time_zones[i].value,
                });
            }

            if ( time_zones.length < 50 )
            {

                ret.push({
                    'divider' : true,
                });

                 ret.push({
                    'text' : 'More Choices',
                    'value' : 'more-choices',
                });

            }

            return ret;
        },

    },
}
</script>

<style lang="scss" scoped>

</style>